import type { Language, Webcast, WebcastContent } from '../../../generated/graphql-manager';

import { useParams } from 'react-router';

import { useGetWebcastNameQuery } from '../../../generated/graphql-manager';

export function useGetWebcastName(): Webcast['name'] {
  const { webcastId = '' } = useParams();
  const { data } = useGetWebcastNameQuery({ variables: { webcastId }, skip: !webcastId });

  return data?.webcast?.name || '';
}

export const getWebcastTitle = (
  language?: Language['code'],
  contents?: Partial<WebcastContent>[]
): WebcastContent['title'] => {
  const title = contents?.find((content) => content.language === language)?.title;
  const fallbackTitle = contents?.[0]?.title;

  return title || fallbackTitle || '';
};
